import { IDataMapper, IEasyfyEvent } from '@shared/easyfy.events/easyfy.eventdata';
import { EventNames } from '@shared/easyfy.events/easyfy.eventhandler';
import { ITrackableElement } from '@shared/easyfy.events/easyfy.eventdata';
import Kevel from '@clientWebModules/kevel';

/* Exporter class */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class KevelDataMapper implements IDataMapper {
  private readonly CLICK_URL: string = 'click-url';
  private readonly IMPRESSION_URL: string = 'impression-url';

  MapEventData(event: IEasyfyEvent): any {
    var mappedEvent: any;
    const eventName = event.eventName.toLowerCase();

    switch (eventName) {
      case EventNames.ElementClick: {
        mappedEvent = this.clickItemEvent(event);
        break;
      }
      case EventNames.ElementImpression: {
        mappedEvent = this.viewItemEvent(event);
        break;
      }
      case EventNames.ProductClick: {
        mappedEvent = this.clickProductEvent(event);
        break;
      }
      case EventNames.ProductImpression: {
        mappedEvent = this.viewProductEvent(event);
        break;
      }
      case EventNames.CompletedCheckout: {
        mappedEvent = this.completedCheckoutEvent(event);
        break;
      }
    }
    return mappedEvent;
  }

  clickItemEvent = async (event: IEasyfyEvent): Promise<void> => {
    const data = event.data as ITrackableElement | undefined;
    const kevelUrl: string = data?.Properties.get(this.CLICK_URL) ?? '';

    if (!kevelUrl) return;
    await this.sendToKevel(kevelUrl);
  };

  viewItemEvent = async (event: IEasyfyEvent): Promise<void> => {
    const data = event.data as ITrackableElement | undefined;
    const kevelUrl: string = data?.Properties.get(this.IMPRESSION_URL);

    if (!kevelUrl) return;
    await this.sendToKevel(kevelUrl);
  };

  clickProductEvent = async (event: IEasyfyEvent): Promise<void> => {
    const kevelUrl = event?.data?.propertyCollection.get(this.CLICK_URL);

    if (!kevelUrl) return;
    await this.sendToKevel(kevelUrl);
  };

  viewProductEvent = async (event: IEasyfyEvent): Promise<void> => {
    const kevelUrls = event?.data?.propertyCollection?.map?.((map) => map.get(this.IMPRESSION_URL)).filter(Boolean) ?? [];

    for (const kevelUrl of kevelUrls) {
      await this.sendToKevel(kevelUrl);
    }
  };

  completedCheckoutEvent = async (event: IEasyfyEvent) => {
    const products = event?.data?.checkoutCompletedProducts;
    const networkId = window?.kevel?.networkId;
    const siteId = window?.kevel?.siteId;
    const transactionId = event?.data?.completedCheckoutId;
    const userKey = Kevel.Instance.getUserId();
    const hasConsentedToCookie = Kevel.Instance.hasConsentedToCookie();
    const timestamp = new Date().toISOString();

    if (!hasConsentedToCookie) return;

    if (!products?.length || !networkId || !siteId || !userKey || !transactionId) {
      console.warn('Missing data for Kevel purchase event');
      return;
    }

    for (const product of products) {
      const productId = product?.productIdentifier;
      const formattedProductId = `${siteId}-${productId}`;
      const quantity = product?.qty;
      const priceExVat = product?.priceExVat;

      if (!productId || quantity == null || priceExVat == null) {
        console.warn('Incomplete product data for Kevel:', product);
        continue;
      }

      const url = new URL(`https://e-${networkId}.adzerk.net/c/${networkId}/purchase`);
      url.searchParams.set('userKey', userKey);
      url.searchParams.set('productId', formattedProductId);
      url.searchParams.set('timestamp', timestamp);
      url.searchParams.set('quantity', String(quantity));
      url.searchParams.set('price', String(priceExVat));
      url.searchParams.set('transactionId', transactionId);

      const urlString = url.toString();
      await this.sendToKevel(urlString);
    }
  };

  private sendToKevel = async (kevelUrl: string): Promise<void> => {
    try {
      await fetch(kevelUrl, { mode: 'no-cors' });
    } catch (error) {
      console.error('Error sending kevel event:', error);
    }
  };
}

declare global {
  interface Window {
    kevel?: {
      networkId?: string;
      siteId?: string;
    };
  }
}
